import React from "react";
import l from "components/util/l";
import ChangeView from "components/util/changes/ChangeView";
import { environmentLabel } from "components/presentation/environments/Environments.lib";

const MergeEnvironmentView = ({
  environments,
  sourceId,
  targetId,
  preview,
  isEmpty,
  isLoadingPreview,
  isApplying,
  onChangeSource,
  onChangeTarget,
  onClickPreview,
  onClickMerge
}) =>
  <div className="card">
    <div className="card-body">

      <h4 className="mb-3">{l("Actualizar entorno%EN010")}</h4>

      <div className="row">
        <div className="col">
          <label className="input-label">{l("Entorno origen%EN008")}</label>
          <select className="form-control form-control-sm" value={sourceId}
            onChange={(event) => onChangeSource(event.target.value)}>
            {environments.map((item) => (
              <option key={item.id} value={item.id}>{environmentLabel(item)}</option>
            ))}
          </select>
        </div>
        <div className="col-auto d-flex align-items-end pb-2">
          <i className="fas fa-arrow-right text-muted"></i>
        </div>
        <div className="col">
          <label className="input-label">{l("Entorno destino%EN009")}</label>
          <select className="form-control form-control-sm" value={targetId}
            onChange={(event) => onChangeTarget(event.target.value)}>
            {environments.filter((item) => item.id != sourceId).map((item) => (
              <option key={item.id} value={item.id}>{environmentLabel(item)}</option>
            ))}
          </select>
        </div>
      </div>

      {
        !preview &&
        <button type="button" className="btn btn-sm btn-primary btn-block mt-3"
          disabled={isLoadingPreview} onClick={onClickPreview}>
          {
            isLoadingPreview
              ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              : l("Ver cambios%EN011")
          }
        </button>
      }

      {
        preview &&
        <div className="mt-4">

          {
            isEmpty
              ? <p style={{ color: "#7b7d7d" }}>{l("No hay cambios que publicar%EN013")}</p>
              : <ChangeView preview={preview} />
          }

          <button type="button" className="btn btn-sm btn-accent btn-block mt-3"
            disabled={isApplying || isEmpty} onClick={onClickMerge}>
            {
              isApplying
                ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                : l("Publicar%PA384")
            }
          </button>

        </div>
      }

    </div>
  </div>

export default MergeEnvironmentView;
